export interface KnowledgeEntry {
  keywords: string[];
  answer: string;
  suggestions?: string[];
}

export const quickPrompts = [
  'What are your minimum order quantities?',
  'How do payments and escrow work?',
  'Which documents come with a shipment?',
  'How long does delivery take?',
  'I want to place an order',
];

export const knowledgeBase: KnowledgeEntry[] = [
  {
    keywords: ['minimum', 'moq', 'smallest', 'least quantity'],
    answer:
      'Minimum lots are: Copper cathodes 100 t · Copper concentrates 500 dmt · Gold 10 kg · Silver 500 kg · Rough diamonds 100 ct · Coloured gemstones 1 kg rough. Trial lots below these can sometimes be arranged for first-time buyers — I can flag that to the desk for you.',
    suggestions: ['How do payments and escrow work?', 'I want to place an order'],
  },
  {
    keywords: ['payment', 'pay', 'escrow', 'letter of credit', 'lc', 'terms', 'deposit'],
    answer:
      'For industrial volumes we work on an irrevocable Letter of Credit at sight against documents, with 90% provisional payment and 10% on final assay for concentrates. Precious metals and gemstones move through a bonded escrow released on sight inspection. We do not ask buyers for advance payment before verification.',
    suggestions: ['Which documents come with a shipment?', 'Can I inspect before paying?'],
  },
  {
    keywords: ['document', 'paperwork', 'certificate', 'assay', 'kimberley', 'origin', 'permit'],
    answer:
      'Every shipment travels with an assay certificate (SGS or Alfred H. Knight), certificate of origin, DRC export permit, packing list, weight note and bill of lading or airway bill. Rough diamond parcels additionally carry a Kimberley Process Certificate with a stone-by-stone manifest.',
    suggestions: ['How long does delivery take?', 'Where are you located?'],
  },
  {
    keywords: ['delivery', 'shipping', 'transit', 'how long', 'lead time', 'freight', 'route'],
    answer:
      'Typical lead times: cathodes and concentrates 18–28 days from LC confirmation via Kasumbalesa to Dar es Salaam or Durban; precious metals 5–9 days by secured air freight; gemstone and diamond parcels 4–7 days to Dubai, Antwerp or Mumbai. We quote CIF, FOB, FCA and DDP.',
    suggestions: ['What are your minimum order quantities?', 'I want to place an order'],
  },
  {
    keywords: ['inspect', 'inspection', 'viewing', 'sample', 'visit', 'see the goods'],
    answer:
      'Yes. Buyers or their appointed agents can inspect at our Lubumbashi warehouse or the Butembo trading office, and diamond and gemstone parcels can be viewed in a bonded room in Antwerp, Dubai or Mumbai. Independent sampling with an umpire assay clause is standard on concentrate contracts.',
    suggestions: ['Which documents come with a shipment?', 'Where are you located?'],
  },
  {
    keywords: ['price', 'cost', 'quote', 'offer', 'lme', 'premium', 'how much'],
    answer:
      'Pricing follows the live benchmark — LME for copper, LBMA for gold and silver — plus or minus a negotiated premium that depends on volume, grade and incoterm. Diamonds and gemstones are priced per parcel after valuation. Send your target volume and destination and the desk will return a firm offer within 24 hours.',
    suggestions: ['I want to place an order', 'How do payments and escrow work?'],
  },
  {
    keywords: ['where', 'located', 'location', 'address', 'office', 'congo', 'lubumbashi', 'butembo'],
    answer:
      'Our head office is in Lubumbashi, Haut-Katanga, DRC, and our trading office is at Av. Bungulu N\u201911, Ville de Butembo, Nord Kivu, DRC. We source and trade across the Democratic Republic of Congo, Zambia and East Africa \u2014 Kenya, Tanzania, Uganda, Rwanda, Burundi, South Sudan, Ethiopia and Somalia \u2014 and export to buyers worldwide.',
    suggestions: ['Who runs the company?', 'I want to place an order'],
  },
  {
    keywords: ['ceo', 'who runs', 'owner', 'management', 'abdul', 'director', 'founded', 'established', 'history'],
    answer:
      'Lumumbashi Minerals SPRL is a mining and trading company established in 2010 and led by CEO Abdul Hasan. It grew from Katangan copper concentrate trading into a mining and trading house exporting gold, silver, copper cathodes, concentrates, rough diamonds and coloured gemstones worldwide.',
    suggestions: ['Where are you located?', 'What do you sell?'],
  },
  {
    keywords: ['what do you sell', 'products', 'commodities', 'catalogue', 'offer list', 'available'],
    answer:
      'We supply gold bullion and dore bars, 999 fine silver, LME Grade A copper cathodes, copper concentrates at 20–32% Cu, Kimberley Process certified rough diamonds, and coloured gemstones including emerald, tourmaline, sapphire and tanzanite.',
    suggestions: ['What are your minimum order quantities?', 'How much does it cost?'],
  },
  {
    keywords: ['order', 'buy', 'purchase', 'place an order', 'enquiry', 'rfq'],
    answer:
      'Two ways to start: use the Place an Order button to open a pre-filled email to our trading desk, or tap the WhatsApp button to message the desk directly for a same-day response. Include commodity, quantity, destination port and preferred incoterm and you will receive a firm offer plus a draft contract.',
    suggestions: ['How do payments and escrow work?', 'How long does delivery take?'],
  },
  {
    keywords: ['whatsapp', 'phone', 'call', 'contact', 'email', 'reach'],
    answer:
      'Tap the WhatsApp button on any page to open a chat with the trading desk, or email sales@lumumbashiminerals.com. The desk is open Monday to Saturday, 07:30–19:00 Central Africa Time, and WhatsApp messages are usually answered within minutes during those hours.',
    suggestions: ['I want to place an order', 'Where are you located?'],
  },
  {
    keywords: ['traceability', 'ethical', 'conflict', 'itsci', 'compliance', 'responsible', 'legal'],
    answer:
      'We are an ITSCI traceability member, all rough diamonds move under the Kimberley Process, and our copper is sourced from licensed concessions with CEEC and ARECOMS export documentation. Chain-of-custody records for any lot are available to buyers on request.',
    suggestions: ['Which documents come with a shipment?', 'Where are you located?'],
  },
];

export const fallbackAnswer =
  'I can help with specifications, minimum quantities, pricing basis, documentation, logistics and payment terms. For anything contract-specific, the fastest route is the WhatsApp button or the Place an Order button — a trader will reply personally.';
